import { DatePickerDate } from '../types';

export default function getEndOfDayDate(date: DatePickerDate) {
  const clonedDate = new Date(date);
  clonedDate.setHours(23, 59, 59, 99);
  return clonedDate;
}
